import { produce } from 'immer';
import { omit } from 'ramda';

import { getWasLoggedIn } from '@interlayer/js/components/system/App/sun/hooks/useBeforeInitHooks/hooks/useSetWasLoggedIn';

import { actionTypes } from './constants';
import { ICustomUserState, TCustomUserStateAction } from './types';

const defaultState: ICustomUserState = {
    wasLoggedIn: getWasLoggedIn(),
    isAdaLoaded: false,
    allPlayerTags: null
};

export const reducer = produce((draftState, action: TCustomUserStateAction): ICustomUserState | void => {
    switch (action.type) {
        case actionTypes.SET_WAS_LOGGED_IN: {
            draftState.wasLoggedIn = action.payload;

            break;
        }

        case actionTypes.SET_ALL_PLAYER_TAGS: {
            draftState.allPlayerTags = action.payload;

            break;
        }

        case actionTypes.UPDATE_PLAYER_TAGS: {
            draftState.allPlayerTags = {
                ...draftState.allPlayerTags,
                ...action.payload
            };

            break;
        }

        case actionTypes.REMOVE_PLAYER_TAG: {
            draftState.allPlayerTags = omit([action.payload], draftState.allPlayerTags);

            break;
        }

        case actionTypes.SET_IS_ADA_LOADED: {
            draftState.isAdaLoaded = action.payload;

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
